import { NestedCSSProperties } from 'typestyle/lib/types';

import { cssClass } from '../../style';

/*
These are common styles being developed in the course of the Spaces project. In many cases they
diverge from the common styles established in CommonStyles.ts or even the TabStyles published
in @tableau/widgets.
*/

export namespace SpacesCommonStyles {
  export const TitleFontSize: number = 26;
  export const SubtitleFontSize: number = 12;
  export const RowHeight: string = '30px';
}

export const GreyedOutTextStyle: React.CSSProperties = {
  color: '#BFBFBF',
  fontWeight: 'inherit'
};

export namespace HiddenUserStyles {
  export const HiddenUserStyle: React.CSSProperties = {
    ...GreyedOutTextStyle
  };

  export const HiddenUserClassName: string = cssClass('UserStyle', 'hidden-user', HiddenUserStyle as NestedCSSProperties);
}
